export interface HousingIqamaApiError {
    phone?: any;
    serviceID?: any;
    numberOfInstallments?: any;
    amount?: any;
    error?: string;
    errors?: string | string[];
}

export const getRowError = (row: HousingIqamaApiError) => {
    if (typeof row.error === 'string' && row.error.trim()) return row.error.trim();
    if (typeof row.errors === 'string' && row.errors.trim()) return row.errors.trim();
    if (Array.isArray(row.errors)) return row.errors.filter(Boolean).map(String).join(', ');
    return '';
};

export const toDownloadableError = (row: HousingIqamaApiError) => ({
    phone: row.phone,
    serviceID: row.serviceID,
    numberOfInstallments: row.numberOfInstallments,
    amount: row.amount,
    error: getRowError(row),
});

export const normalizeFailedRow = (row: HousingIqamaApiError, index: number) => ({
    key: row.phone || index,
    phone: row.phone,
    serviceID: row.serviceID,
    amount: row.amount,
    numberOfInstallments: row.numberOfInstallments,
    error: getRowError(row),
});

export const buildFailedHousingIqamaResult = (apiErrors: HousingIqamaApiError[]) => {
    const failedSource = apiErrors.filter((row) => getRowError(row));
    return {
        failedRows: failedSource.map(normalizeFailedRow),
        rejectedRequests: apiErrors.map(toDownloadableError),
        count: failedSource.length,
    };
};
